<template>
  <div >
    <div class="design_box_out">
      <!--<div class="tool_company">-->
      <div class="company-desc design_box">
        {{property.body}}
      </div>
      <!--</div>-->
    </div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
      form: {}
    };
  }
};
</script>


